import DeviceGroup from "./DeviceGroup.js";
import DeviceGroupId from "./DeviceGroupId.js";
import DeviceType from "./DeviceType.js";
import FirmwareIsUpgrading from "./FirmwareIsUpgrading.js";
import FirmwareUpgradeDuration from "./FirmwareUpgradeDuration.js";
import FirmwareUpgradeErrors from "./FirmwareUpgradeErrors.js";
import FirmwareUpgradeStartedAt from "./FirmwareUpgradeStartedAt.js";
import ForceFirmwareRetry from "./ForceFirmwareRetry.js";
import IntermediaryFirmwareComponents from "./IntermediaryFirmwareComponents.js";
import IsActive from "./IsActive.js";
import Metadata from "./Metadata.js";
import ReportedFirmwareApplication from "./ReportedFirmwareApplication.js";
import ReportedFirmwareApplicationId from "./ReportedFirmwareApplicationId.js";
import ReportedFirmwareComponents from "./ReportedFirmwareComponents.js";
import DeviceTypeId from "./DeviceTypeId.js";
import Id from "./Id.js";
import ImagineGroup from "./ImagineGroup.js";
import ImagineGroupId from "./ImagineGroupId.js";
import ImagineGroupName from "./ImagineGroupName.js";
import ProjectId from "./ProjectId.js";
import Name from "./Name.js";
export default {
  DeviceGroup,
  DeviceGroupId,
  DeviceType,
  FirmwareIsUpgrading,
  FirmwareUpgradeDuration,
  FirmwareUpgradeErrors,
  FirmwareUpgradeStartedAt,
  ForceFirmwareRetry,
  IntermediaryFirmwareComponents,
  IsActive,
  Metadata,
  ReportedFirmwareApplication,
  ReportedFirmwareApplicationId,
  ReportedFirmwareComponents,
  DeviceTypeId,
  Id,
  ImagineGroup,
  ImagineGroupId,
  ImagineGroupName,
  ProjectId,
  Name
};
export { DeviceGroup, DeviceGroupId, DeviceType, FirmwareIsUpgrading, FirmwareUpgradeDuration, FirmwareUpgradeErrors, FirmwareUpgradeStartedAt, ForceFirmwareRetry, IntermediaryFirmwareComponents, IsActive, Metadata, ReportedFirmwareApplication, ReportedFirmwareApplicationId, ReportedFirmwareComponents, DeviceTypeId, Id, ImagineGroup, ImagineGroupId, ImagineGroupName, ProjectId, Name };